"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CountrySelectorFilterable;
var _api = require("@whitbread-eos/api");
var _atoms = require("@whitbread-eos/atoms");
var _utils = require("@whitbread-eos/utils");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function CountrySelectorFilterable(_ref) {
  var _formField$props, _formField$testid, _formField$props2, _formField$props3;
  var {
    formField,
    field,
    selectedId,
    setIsLocationRequired
  } = _ref;
  var [countries, setCountries] = (0, _react.useState)([]);
  var [selectedCountry, setSelectedCountry] = (0, _react.useState)();
  var [countryCodeValue, setCountryCodeValue] = (0, _react.useState)({
    countryCode: ''
  });
  var hasSetDefault = (0, _react.useRef)(false);
  var currentLang = ((_formField$props = formField.props) === null || _formField$props === void 0 ? void 0 : _formField$props.currentLang) || _utils.GLOBALS.language.EN;
  var country = currentLang === _utils.GLOBALS.language.EN ? _utils.GLOBALS.locale.GB : _utils.GLOBALS.locale.DE;
  var testId = (_formField$testid = formField.testid) !== null && _formField$testid !== void 0 ? _formField$testid : 'CountrySelectorFilterable';
  var {
    data: countriesData,
    isSuccess: countriesRequestSuccess
  } = (0, _utils.useQueryRequest)(['GetCountries', country, currentLang, _api.SITE_LEISURE], _api.GET_COUNTRIES, {
    country,
    language: currentLang,
    site: _api.SITE_LEISURE
  });
  (0, _react.useEffect)(() => {
    if (!field.value) {
      hasSetDefault.current = false;
    }
  }, [field.value]);
  function setDefaultCountry(countries, code) {
    var country = countries.find(c => c.countryCode === code);
    if (!country && code) {
      country = countries.find(c => c.countryCodeLegacy === code);
    }
    if (country) {
      var _field$onChange;
      setSelectedCountry(country);
      setCountryCodeValue({
        countryCode: country.countryCode
      });
      (_field$onChange = field.onChange) === null || _field$onChange === void 0 || _field$onChange.call(field, country.countryCode);
    }
  }
  (0, _react.useEffect)(() => {
    var _countriesData$countr;
    if (!countriesRequestSuccess) return;
    var loadedCountries = (countriesData === null || countriesData === void 0 || (_countriesData$countr = countriesData.countries) === null || _countriesData$countr === void 0 ? void 0 : _countriesData$countr.countries) || [];
    setCountries(prev => {
      var prevCodes = prev.map(c => c.countryCode).join(',');
      var newCodes = loadedCountries.map(c => c.countryCode).join(',');
      return prevCodes === newCodes ? prev : loadedCountries;
    });
    if (!field.value && !hasSetDefault.current) {
      hasSetDefault.current = true;
      setDefaultCountry(loadedCountries, selectedId || (currentLang === 'en' ? 'GB' : 'DE'));
    }
  }, [countriesRequestSuccess, countriesData, selectedId, currentLang, field.value]);
  (0, _react.useEffect)(() => {
    if (!countries.length || !field.value) return;
    var found = countries.find(c => c.countryCode === field.value);
    setSelectedCountry(found);
    if (found) setCountryCodeValue({
      countryCode: found.countryCode
    });
  }, [field.value, countries]);
  var onChange = countryValue => {
    var _field$onChange2;
    setCountryCodeValue(countryValue);
    setIsLocationRequired === null || setIsLocationRequired === void 0 || setIsLocationRequired(countryValue.countryCode === 'DE');
    (_field$onChange2 = field.onChange) === null || _field$onChange2 === void 0 || _field$onChange2.call(field, countryValue.countryCode);
  };
  return (0, _jsxRuntime.jsx)(_atoms.CountryInput, {
    value: countryCodeValue,
    label: formField.label,
    name: formField.name,
    dataTestId: testId,
    onChange: onChange,
    countries: countries,
    formatAssetsUrl: _utils.formatAssetsUrl,
    placeholder: selectedCountry ? selectedCountry.countryName : formField.label,
    currentLang: currentLang,
    inputProps: {
      className: formField === null || formField === void 0 || (_formField$props2 = formField.props) === null || _formField$props2 === void 0 ? void 0 : _formField$props2.className
    },
    useTooltip: formField === null || formField === void 0 || (_formField$props3 = formField.props) === null || _formField$props3 === void 0 ? void 0 : _formField$props3.useTooltip
  });
}